import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _typeof from "@babel/runtime/helpers/esm/typeof";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, mixins, Prop } from 'nuxt-property-decorator';
import LoaderMixin from '@core/mixins/LoaderMixin';
var HorizontalTemplate = /*#__PURE__*/function (_mixins) {
  _inherits(HorizontalTemplate, _mixins);
  var _super = _createSuper(HorizontalTemplate);
  function HorizontalTemplate() {
    var _this;
    _classCallCheck(this, HorizontalTemplate);
    _this = _super.apply(this, arguments);
    /* Watch */
    /* Data */
    _this.showMenu = true;
    /* Events/Listeners */
    return _this;
  }
  /* Enums */
  /* Lifecycle */
  /* Computed */
  _createClass(HorizontalTemplate, [{
    key: "hasMenu",
    get: function get() {
      return !!this.$slots.menu;
    }
    /* Methods */
  }, {
    key: "toggleMenu",
    value: function toggleMenu() {
      this.showMenu = !this.showMenu;
    }
  }]);
  return HorizontalTemplate;
}(mixins(LoaderMixin));
__decorate([Prop({
  required: false,
  type: Boolean,
  default: false
})], HorizontalTemplate.prototype, "toggleable", void 0);
HorizontalTemplate = __decorate([Component({
  components: {}
})], HorizontalTemplate);
export default HorizontalTemplate;